/** Image de référence du catalogue (1055 px de large). */
export const templateImageUrl = (template: string) => `/templates/webp/${template}.webp`;

/** Vignette allégée (560 px), générée au build depuis l'image de référence (vite.config.ts). */
export const templateCardUrl = (template: string) => `/templates/cards/${template}.webp`;
